import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import { ServiceCard } from '../../ServiceCard'
import { ServiceNoResultsCard } from '../../ServiceNoResultsCard'
import { Props as ServiceListProps } from '../ServiceList'

type Props = Pick<
  ServiceListProps,
  | 'deleteWarningMessage'
  | 'disableEdit'
  | 'entityType'
  | 'localMode'
  | 'minimumServicesCount'
  | 'onEditClick'
  | 'serviceFrequencies'
  | 'readOnly'
  | 'services'
  | 'totalServicesCount'
>

export function OldServiceContents(props: Props) {
  const { minimumServicesCount, services, totalServicesCount } = props

  const theme = useTheme()

  return (
    <div style={{ width: '100%', marginBottom: theme.spacing(2.8) }}>
      {services.length > 0 ? (
        services.map((s, i) => (
          <ServiceCard
            key={s.id}
            service={s}
            index={i}
            {...props}
            frequency={props.serviceFrequencies.find(
              (x) => x.id == s.frequencyId,
            )}
            disableDelete={
              !!totalServicesCount &&
              !!minimumServicesCount &&
              totalServicesCount <= minimumServicesCount
            }
            deleteWarningMessage={props.deleteWarningMessage ?? ''}
            readOnly={props.readOnly}
          />
        ))
      ) : (
        <ServiceNoResultsCard label="No Services or Products Added" />
      )}
    </div>
  )
}
